import { logError } from './log';

const handleError = error => {
	if ( error.response ) {
		logError( 'A request was made to the API and the server responded with a status code that falls outside of the range of 2xx', error.response.status );
		logError( error.response.data );

		// return error.response.data.message;
		return error.response.data.Response
			? error.response.data.Response
			: 'An error has occurred and we were unable to process your request. Please refresh your browser and try again. If the error persists, please contact support.';
	} else if ( error.request ) {
		logError( 'A request was made to the API but no response was received' );
		logError( error.request );

		return 'An error has occurred and we were unable to process your request. Please refresh your browser and try again. If the error persists, please contact support.';
	}

	logError( error.message );

	return 'An error has occurred and we were unable to process your request. Please refresh your browser and try again. If the error persists, please contact support.';
};

export default handleError;
